export const characterPreviewMessages = {
  // Loading state
  generatingPreview: 'Generating character preview...',

  // Header
  title: 'Character Preview',
  subtitle: "Here's how your characters look",
} as const;
